import storageSpec from "./storage/Spec.json"
import identitySpec from "./identity/Spec.json"
import campaignsSpec from "./campaigns/Spec.json"
import documentsSpec from "./documents/Spec.json"
import backstageSpec from "./backstage/Spec.json"
import activitiesSpec from "./activities/Spec.json"
import investmentsSpec from "./investments/Spec.json"
import transactionsSpec from "./transactions/Spec.json"
import organizationsSpec from "./organizations/Spec.json"
import notificationsSpec from "./notifications/Spec.json"

const SPECS_MAP = {
  storage: storageSpec,
  identity: identitySpec,
  backstage: backstageSpec,
  documents: documentsSpec,
  campaigns: campaignsSpec,
  activities: activitiesSpec,
  investments: investmentsSpec,
  transactions: transactionsSpec,
  organizations: organizationsSpec,
  notifications: notificationsSpec,
}

export const getSpec = service => {
  const spec = SPECS_MAP[service]

  if (!spec) {
    throw new Error(`Spec for "${service}" service is not found`)
  }

  return spec
}

export const getComponentByPath = (operation, path) => {
  const [ service ] = operation.split('/')
  const spec = getSpec(service)

  if (!path) {
    throw new Error(`Path is not defined for operation ${operation}`)
  }

  const componentName = path.replace('#/definitions/', '')
  const component = spec.definitions[componentName]

  if (!component) {
    throw new Error(`
      Component "${componentName}" is not found at path "${path}".
      Check specification for operation "${operation}".
    `)
  }

  return component
}

export const getIndexOperationOutputProperties = operation => {
  const [ service, operationId ] = operation.split('/')
  const spec = getSpec(service)

  const outputComponentName = `${operationId}Output`
  const outputComponent = spec.definitions[outputComponentName]

  if (!outputComponent) {
    throw new Error(`
      Operation "${operationId}" is not found.
      Check specification for service "${service}".
    `)
  }

  const itemComponentPath = outputComponent.properties.data.items.$ref
  const itemComponent = getComponentByPath(operation, itemComponentPath)

  const { properties } = itemComponent

  return properties
}

export const getMutationOperationInputProperties = operation => {
  const [ service, operationId ] = operation.split('/')
  const spec = getSpec(service)

  const outputComponentName = `${operationId}InputMutation`
  const outputComponent = spec.definitions[outputComponentName]

  if (!outputComponent) {
    throw new Error(`
      Operation "${operationId}" is not found.
      Check specification for service "${service}".
    `)
  }

  const { properties, required = [] } = outputComponent

  for (const key of required) {
    properties[key].isRequired = true
  }

  return properties
}

export const getMutationOperationOutputProperties = operation => {
  const [ service, operationId ] = operation.split('/')
  const spec = getSpec(service)

  const outputComponentName = `${operationId}Output`
  const outputComponent = spec.definitions[outputComponentName]

  if (!outputComponent) {
    throw new Error(`
      Operation "${operationId}" is not found.
      Check specification for service "${service}".
    `)
  }

  let component = outputComponent.properties.data
  const { $ref: componentPath } = component

  if (componentPath) {
    component = getComponentByPath(operation, componentPath)
  }

  const { properties, required = []  } = component

  for (const key of required) {
    properties[key].isRequired = true
  }

  return properties
}

export const isEnum = (operation, componentPath) => {
  if (!componentPath) { return false }

  const component = getComponentByPath(operation, componentPath)
  const { enum: _enum } = component
  const hasEnum = !!_enum

  return hasEnum
}

export const isCreate = operation =>
  operation.includes("/Send") ||
  operation.includes("/Create") ||
  operation.includes("/Import") ||
  operation.includes("/Connect") ||
  operation.includes("/ChangeMyIdentityEmail") ||
  operation.includes("/ConfirmMyIdentityEmail")
